import { createSelector } from "reselect";

// Constants
import { privacyPolicyDisabledPartners } from "src/constants";

// Selectors
import { partnerNameSelector } from "../partner_name_selector";

/**
 * Memoized selector to get the Disabled/Enabled state
 * of the Privacy Policy Modal Button on Settings Page
 * When the Privacy Policy Modal Button is disabled the Modal cannot
 * be opened and closed and will not be shown.
 */
export const privacyPolicyButtonEnabledSelector = createSelector(
  partnerNameSelector,
  partnerName => {
    if (privacyPolicyDisabledPartners.includes(partnerName)) {
      return false;
    }
    return true;
  }
);
